"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orta-san-giulio": {
    "b47d7636": [{
      "hkey": "c1f7141c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "imolo": [{
      "hkey": "c1f7141c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "orta-san-giulio"
    }],
    "6022db08": [{
      "hkey": "c1f7141c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "legro": [{
      "hkey": "c1f7141c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "orta-san-giulio"
    }],
    "65cad103": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "skipSearch": false
    }],
    "palma": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e8d1663": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "skipSearch": false
    }],
    "sacro-monte": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f5f32bc": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "skipSearch": false
    }],
    "stresa": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25483d63": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "2c9c98e5",
      "slug": "orta-san-giulio",
      "name": "Orta San Giulio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;